module.exports = __webpack_public_path__ + "static/img/round-49-triple.957b816.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/amenities/receptacles/round-49-triple.jpg
// module id = 611
// module chunks = 0